export const substringToEnd = (index: number) => (str: string) =>
  str.substring(index);
